export const MOVIMENTACAO_UNIDADE_DIAS = 1;
export const MOVIMENTACAO_UNIDADE_MONETARIA = 2;
export const MOVIMENTACAO_UNIDADES_HORAS = [0, 8];
